import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Add_StaffSkillsInDatabase,
  AddEventInDataBase,
  AddSkillsInDatabase,
  AddStaff,
} from "../../CrudOperations/PostOperation";
import { getAllStaff, getSkillList } from "../../CrudOperations/GetOperation";
import { updateStaffSkillInDataBase } from "../../CrudOperations/Update&Edit";

const AddStaffSkills = ({ closeModal, onSubmit, StaffSkill, onUpdate }) => {
  const [StaffId, setStaffId] = useState(StaffSkill ? StaffSkill.StaffId : "");
  const [SkillsId, setSkillsId] = useState(
    StaffSkill ? StaffSkill.SkillId : ""
  );
  const [Status, setStatus] = useState(StaffSkill ? StaffSkill.Status : "");

  const [staffList, setStaffList] = useState([]);
  const [SkillList, setSkillList] = useState([]);

  useEffect(() => {
    const fun = async () => {
      const [staffList_response, skillList_response] = await Promise.all([
        getAllStaff(),
        getSkillList(),
      ]);

      console.log(staffList_response);
      console.log(skillList_response);

      if (staffList_response && staffList_response.data.Message === "Success") {
        setStaffList(staffList_response.data.Data);
      }

      if (skillList_response && skillList_response.data.Message === "Success") {
        setSkillList(skillList_response.data.Data);
      }
    };

    fun();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!StaffSkill) {
      const response = await Add_StaffSkillsInDatabase(
        StaffId,
        SkillsId,
        Status
      );

      console.log(response);

      if (response.data.ServerMessage === "Staff skill added successfully.") {
        onSubmit(); // Handle new data
      }
    } else {
      const response = await updateStaffSkillInDataBase(
        StaffSkill.StaffSkillId,
        StaffId,
        SkillsId,
        Status
      );

      console.log(response);

      if (response.data.ServerMessage === "Staff skill updated successfully.") {
        onSubmit(); // Handle new data
      }
    }
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 ${"block"}`}
    >
      <div className="bg-white rounded-lg p-4 w-1/3 shadow-lg">
        <h2 className="text-lg font-bold mb-3">
          {StaffSkill ? "Edit Staff" : "Add Skill"}
        </h2>
        <form onSubmit={handleFormSubmit}>
          <div className="mb-2">
            <label className="block text-gray-700">Deputy Name *</label>

            <select
              value={StaffId}
              onChange={(e) => setStaffId(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Deputy</option>
              {staffList.map((staff) => (
                <option key={staff.StaffId} value={staff.StaffId}>
                  {staff.FullName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Skill Name *</label>
            {/* <input
              type="text"
              value={SkillsId}
              onChange={(e) => setSkillsId(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            /> */}

            <select
              value={SkillsId}
              onChange={(e) => setSkillsId(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Skill</option>
              {SkillList.map((skill) => (
                <option key={skill.SkillId} value={skill.SkillId}>
                  {skill.SkillName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Status *</label>
            <select
              value={Status}
              onChange={(e) => setStatus(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              required
            >
              <option value="">Select Status</option>
              <option key={1} value={1}>
                Active
              </option>

              <option key={0} value={0}>
                InActive
              </option>
            </select>
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="bg-gray-300 px-3 py-1 rounded-md mr-2"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="bg-blue-600 text-white px-3 py-1 rounded-md"
            >
              {StaffSkill ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStaffSkills;
